export const CMSVersionPublished = 'published';
export const CMSVersionDraft = 'draft';
//# sourceMappingURL=cms-version-status.js.map